import { AccommodationTypeList } from '@data/models';
import { apiCall } from '../axios';
export class AccommodationsTypeService {
    static load(propertyId) {
        return new Promise((resolve, reject) => {
            const url = '/rooms';
            const params = {
                checkin: '1970-01-01',
                checkout: '1970-01-02',
                widget_property: propertyId,
            };
            apiCall(AccommodationTypeList)('post', url, params)
                .then((res) => {
                const accommodationList = res;
                resolve(accommodationList);
            })
                .catch(reject);
        });
    }
}
